module.exports = __webpack_public_path__ + "img/porfolio.69df54b6.svg";